import React from "react";
import SummaryDetailsItem from "@/src/components/Form/Common/SummaryDetailsItem/SummaryDetailsItem";
import SummaryDetailsProps from "@/src/types/SummaryDetailsProps";

const SummaryDetailsSubscription = ({ caseData }: SummaryDetailsProps) => {
  return (
    <>
      <SummaryDetailsItem fieldPath={"wasDeceived"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={"salesChannel"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={"subscriptionName"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={"contractNumber"} caseData={caseData} />
    </>
  );
};

export default SummaryDetailsSubscription;
